import { createContext } from 'react';

export type AuthMode = 'login' | 'register' | 'forgot';

export interface AuthDialogOptions {
  /** Where to go once signed in. Omitted means "stay where you are". */
  next?: string | undefined;
  /**
   * Where to go when the dialog is dismissed.
   *
   * Set only when the dialog was opened by a URL — a visitor who lands on
   * `/login` and closes it has to end up somewhere, and leaving them on a bare
   * `/login` with nothing on it would be a dead end.
   */
  closeTo?: string | undefined;
}

export interface AuthDialogValue {
  /** Null when nothing is open. */
  mode: AuthMode | null;
  open: (mode: AuthMode, options?: AuthDialogOptions) => void;
  /** Switches tab without re-running the open animation or losing the redirect target. */
  setMode: (mode: AuthMode) => void;
  close: () => void;
}

export const AuthDialogContext = createContext<AuthDialogValue | null>(null);
